import { useLocation, useParams } from "react-router-dom";
import "./CadastroAccessRoutes.css";
import { useEffect, useState } from "react";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import AccessRouteService from "../../../services/AccessRoutesService";
import { FormAccessRoutes } from "../FormAccessRoutes/FormAccessRoutes";

export const CadastroAccessRoutes = () => {
   const { accessRouteId } = useParams();
   const { state } = useLocation();
   const [accessRoute, setAccessRoute] = useState(state);
   const [type, setType] = useState("");

   async function loadAccessRoute(id) {
      const response = await AccessRouteService.getOneUuid(id);
      if (response.data) {
         setAccessRoute(response.data);
      }
   }

   useEffect(() => {
      setType(accessRouteId || state ? "edicao" : "cadastro");
      if (accessRouteId) {
         loadAccessRoute(accessRouteId);
      }
   }, [state, accessRouteId]);

   return (
      <CadastroContainer>
         <FormAccessRoutes accessRoute={accessRoute} type={type} />
      </CadastroContainer>
   );
};

